export default (searchedBy, filters, agenda, covenant) => {
  searchedBy.push(covenant.label)

  if (!agenda.covenant_type) {
    return
  }
  filters['covenants'] = {
    covenant_type: agenda.covenant_type
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterByCovenantType.js